/* eslint-disable jsx-a11y/alt-text */
import * as React from 'react'
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { RainbowButton } from '../RainbowButton'

export const DownloadAndDiscordButtons: React.FC = () => {
  return (
    <div className={styles.installButton}>
      <div className={styles.wrapper}>
        <RainbowButton reverse href='/chatbot/download'>
          <FontAwesomeIcon icon={faDownload} className={styles.icon} />
          <b>
            Download <em>Draco.Bot</em>
          </b>
        </RainbowButton>
      </div>
      <div className={styles.wrapper}>
        <RainbowButton href='https://discord.gg/5s2rhp8qBq'>
          <FontAwesomeIcon icon={faDiscord as IconDefinition} className={styles.icon} />
          <b>Join our Discord</b>
        </RainbowButton>
      </div>
    </div>
  )
}

export default DownloadAndDiscordButtons
